const creatEditableDivInBody = () => {
    const extraDiv = document.createElement('div');
    extraDiv.setAttribute('contenteditable', 'true');
    extraDiv.setAttribute('tabindex', '0');
    extraDiv.style.cssText = 'position: absolute; left: -999px; top: 0; width: 0; height: 0';
    return extraDiv;
};

export default creatEditableDivInBody;
